<template>
  <div>
    <p v-if="!canRedirect">Redirect not allowed. Missing tracking data.</p>
    <p v-else>Redirecting...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canRedirect: true
    }
  },
  mounted() {
    const domainName = 'magazine.co.uk'

    const query = this.$route.query
    let campaignID = ''
    let materialID = ''
    let affiliateID = ''
    let reference = ''
    let redirectURL = ''
    let canRedirect = true

    if (query.campaignID) {
      campaignID = query.campaignID
      materialID = query.materialID || ''
      affiliateID = query.affiliateID || ''
      redirectURL = query.redirectURL || ''
    } else if (query.tt) {
      const trackingData = query.tt.split('_')
      campaignID = trackingData[0] || ''
      materialID = trackingData[1] || ''
      affiliateID = trackingData[2] || ''
      reference = trackingData[3] || ''
      redirectURL = query.r || ''
    } else {
      canRedirect = false
    }

    if (canRedirect && campaignID) {
      // Generate checksum
      const rawCheck = `CHK_${campaignID}::${materialID}::${affiliateID}::${reference}`
      const checksum = this.md5(rawCheck)

      // Create tracking cookie (expires in 1 year)
      const cookieName = `TT2_${campaignID}`
      const cookieValue = `${materialID}::${affiliateID}::${reference}::${checksum}::${Math.floor(Date.now() / 1000)}`
      const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()
      document.cookie = `${cookieName}=${encodeURIComponent(cookieValue)}; path=/; domain=.${domainName}; expires=${expires}`

      // Redirect
      const trackBackURL = `http://tc.tradetracker.net/?c=${campaignID}&m=${materialID}&a=${affiliateID}&r=${encodeURIComponent(reference)}&u=${encodeURIComponent(redirectURL)}`
      window.location.replace(trackBackURL)
    } else {
      this.canRedirect = false
    }
  },
  methods: {
    // Basic MD5 implementation
    md5(string) {
      return require('crypto')
        .createHash('md5')
        .update(string)
        .digest('hex')
    }
  }
}
</script>
